import React, { useEffect } from 'react';
import './Dynamic.css';
import DarkNav from './DarkNav';
import Footer from './Footer';

function Dynamic() {

      useEffect(() => {
    window.scrollTo(0,0);
},[])
    

  return (
    <div className='dynamic'>
        <DarkNav />

        <div className='dynamic_hero'>
            <div className='dynamic_hero_text'>
                <p>Integrating</p>
                <h1>Artificial Intelligence</h1>
                <p>into Rocket’s lead gen form</p>
            </div>
            <div className='dynamic_hero_image'>
                <img src="/images/Dynamic_hero.svg" alt="hero image" />
            </div>
        </div>


        <div className='project_Info_DynamicCover'>
                    <div className=' project_Info_Dynamic'>
                        <h5>TIMELINE</h5>
                        <p>July 2024 - August 2024</p>
                    </div>
                    <div className=' project_Info_Dynamic'>
                        <h5>ROLE</h5>
                        <p>Assoc.Product Designer (Prototyping)</p>
                    </div>
                    <div className=' project_Info_Dynamic'>
                        <h5>TOOLS</h5>
                        <p>Figma </p>
                    </div>
                    <div className=' project_Info_Dynamic'>
                        <h5>PROJECT TYPE</h5>
                        <p>Industry</p>
                    </div>
                    <div className=' project_Info_Dynamic'>
                        <h5>TEAM</h5>
                        <p>1 Sr. Product Designer <br />
                           1 Content Writer<br />
                           2 PMs</p>
                    </div>
                    <div className=' project_Info_Dynamic'>
                        <h5>PROJECT FOCUS</h5>
                        <p>Prototyping <br />
                        Visual Design <br />
                        Experinece Design <br />
                        AI
                        </p>
                    </div>
         </div>

        <div className='border2 border3'></div>


        <div className='project_Overview'>
                <div className='project_Overview_Left' id='overview'>
                    <p>OVERVIEW</p>
                    <div className='project_Overview_Left_Link'>
                        <p><a data-scroll style={{textDecoration:"none", color:"#000000"}} href='#solution'>SKIP TO THE JUICY PART</a></p>
                        <img src='/images/RocketLinkArrow.svg' alt="link arrow" />
                    </div>
                </div>
                <div className='project_Overview_Right'>
                  <h2>ABOUT ROCKET MORTGAGE</h2>
                    <p>Rocket Mortgage is America’s largest mortgage lender, helping millions achieve the dream of home ownership. Their mission is to  make the complicated home financing process simpler</p>
                    <br />
                    <h2>WHAT DOES THE LEAD GENERATION TEAM DO?</h2>
                    <p>The lead generation team operates at the top of the mortgage platform funnel. We provide users with a form to fill out, and then we connect them with a banker, aiming to successfully convert them into customers.</p>
                </div>
            </div>


            <div className='project_Overview'>
                <div className='project_Overview_Left' id='overview'>
                    <img src='/images/Dynamic.gif' alt="actionbar gif" />
                    
                </div>
                <div className='project_Overview_Right project_Overview_Right_Dynamic'>
                  <h2>What is <span>ActionBar</span></h2>
                    <p>Introducing a new component, that shows users their progress, gives insights and hidden knowledge about mortgage stuff that people might be unknown about, eventually creating a beautiful experience.</p>
                </div>
            </div>


            <div className='dynamic_multiple_image'>
                <img src='/images/DyComponents.svg' alt="image" />
            </div>


            <div className='project_Research_Header old_version'>
                <div className='project_Research_Header_Left old_version_left'>
                <div className='project_Research_Header_Left_Top'>

                </div>
                <div className='project_Research_Header_Left_Bottom'>
                    {/* <p>Revamp the experience:</p> */}
                </div>

                </div>
                <div className='project_Research_Header_Right old_version_right'>
                    <div className='project_Research_Header_Right_Top'>
                        <h1>The</h1>
                        <h1>Need</h1>
                    </div>
                    <div className='project_Research_Header_Right_Bottom project_Research_Header_Right_Bottom_Rocket'>
                        <h1> &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp;                                                  We wanted to do build something cool, something unique for the users.</h1>
                        <p>We wanted to guide them on every single step of the form, give them insights, hidden knowledge about mortgage and lastly show them the progress. </p>
                    </div>
                </div>
            </div>

            <div className='outcome_Image2'>
            {/* <video controls loop autoplay>
                <source src="my_movie.mp4" type="video/mp4">
                Dynamic bar demo
            </video> */}
            
                <img src='/images/comp.gif' alt="outcome image" />
            </div>


            <div className='project_Research_Header old_version the_outcome'>
                <div className='project_Research_Header_Left old_version_left'>
                <div className='project_Research_Header_Left_Top'>

                </div>
                <div className='project_Research_Header_Left_Bottom'>
                    {/* <p>Revamp the experience:</p> */}
                </div>

                </div>
                <div className='project_Research_Header_Right old_version_right'>
                    <div className='project_Research_Header_Right_Top'>
                        <h1>The</h1>
                        <h1>Outcome</h1>
                    </div>
                    <div className='project_Research_Header_Right_Bottom project_Research_Header_Right_Bottom_Rocket'>
                        {/* <h1> &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp;                                                  We wanted to do build something cool, something unique for the users.</h1> */}
                        <p>This demo was presented by our CTO on AWS Re:invent 2025 in Las Vegas and by our CBO in investor day 2024 which was presented to 15+ wall street investors including people from Chase, Fidelity etc. </p>
                    </div>
                </div>

            </div>

            <div className='outcome_Image'>
                <img src='/images/outcome.png' alt="outcome image" />
            </div>

            <div className='give_try'>
                <p>Want to <span>try it out?</span></p>
               <a target={'_blank'} href='https://www.figma.com/proto/yIh5iMDN8koVbc61JcinLN/Portfolio?page-id=0%3A1&node-id=493-13882&viewport=-8928%2C-773%2C0.18&t=hnYkbLGMaAhyWNhi-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=493%3A13842&show-proto-sidebar=1'>
                 <img src="/images/Figma_link.svg" alt="figma_link" /> 
                </a>
            </div>

        
            <div className='border2 border3'></div>



            {/* <div className='numbers_rocket'>
              <p>Results</p>
              <img src="/images/Results_Dynamic.svg" alt="results" />
            </div>


            <div className='border2 border3'></div> */}


            <div className='project_Reflection'>
                <h2>WHAT DID I LEARN</h2>
                <div className='project_Reflection_Text'>
                    <div className='project_Reflection_Text_Left'>
                        <img src="/images/prototyping.svg" alt="reflection image" />
                        <h2>Prototyping</h2>
                        <p>This was a super prototyping heavy project and I had pushed by boundaries. I learnt that showings screens first rather than 5-10 prototypes every time, saves a lot of time!</p>
                    </div>
                    <div className='project_Reflection_Text_Middle'>
                        <img src="/images/Simplicity.svg" alt="reflection image" />
                        <h2>Simplicity is the best policy</h2>
                        <p>Condensing a lot of info in a small space that is also friendly and simple to use was quite a task. So UX before UI was the main thing here. </p>
                    </div>
                    <div className='project_Reflection_Text_Right'>
                        <img src="/images/Empathy.svg" alt="reflection image" />
                        <h2>Empathize with everyone and embrace feedback</h2>
                        <p>Show compassion and understanding towards all individuals, fostering a culture of inclusivity. Welcome feedback as a valuable tool for personal growth and continuous improvement.</p>
                    </div>
                </div>
             </div>
             <br />
             <br />
             <br />

             <div className='give_try' style={{width:"70%", margin:"auto"}}>
                <p>After this project I was recognized in the company as someone who has really good prototyping and animation skills </p>
               
            </div>
             <Footer />




            






    </div>
  )
}

export default Dynamic
